import { Box, CircularProgress, Tooltip, Typography } from '@mui/material'
import { useControlStore } from '@editor/stores'
import { Html } from '@react-three/drei'
import { SceneErrorState, useSceneErrorStore } from '../sceneErrorStore'

const SPINNER_SIZE = 20
const MARGIN = 32
const GAP = 12

const ErrorIcon = ({ message }: { message: string }) => {
  return (
    <Tooltip title={message} placement="left" arrow>
      <Box
        sx={{
          width: SPINNER_SIZE,
          height: SPINNER_SIZE,
          borderRadius: '50%',
          bgcolor: 'error.main',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          userSelect: 'none',
        }}
      >
        <Typography
          component="span"
          sx={{
            color: 'common.white',
            fontWeight: 900,
            fontSize: 14,
            lineHeight: 1,
          }}
        >
          X
        </Typography>
      </Box>
    </Tooltip>
  )
}

const SceneLoadingIndicator = () => {
  const sceneLoadingIndicators = useControlStore(state => state.sceneLoadingIndicators)
  const errorMessage = useSceneErrorStore((state: SceneErrorState) => state.errorMessage)

  if (sceneLoadingIndicators.length === 0 && !errorMessage) return null

  const tooltipTitle = (
    <Box component="span" sx={{ display: 'block' }}>
      <Typography variant="caption" component="span" sx={{ display: 'block', fontWeight: 600 }}>
        Lädt:
      </Typography>
      {sceneLoadingIndicators.map(({ id, description }) => (
        <Typography key={id} variant="caption" component="span" sx={{ display: 'block' }}>
          • {description ?? id}
        </Typography>
      ))}
    </Box>
  )

  return (
    <Html
      position={[0, 0, 0]}
      calculatePosition={(_el, _camera, size) => [size.width - MARGIN, size.height - MARGIN]}
      style={{ pointerEvents: 'none', transform: 'translate(-100%, -100%)' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: `${GAP}px`,
          pointerEvents: 'auto',
        }}
      >
        {errorMessage && <ErrorIcon message={errorMessage} />}

        {sceneLoadingIndicators.length > 0 && (
          <Tooltip title={tooltipTitle} placement="left" arrow>
            <Box sx={{ display: 'inline-flex' }}>
              <CircularProgress size={SPINNER_SIZE} sx={{ color: 'grey.500' }} />
            </Box>
          </Tooltip>
        )}
      </Box>
    </Html>
  )
}

export default SceneLoadingIndicator
